import { useCheckoutConfig } from './useCheckoutConfig'

export const useStartCheckoutPath = () => {
  const [first] = useCheckoutConfig()

  if (!first) {
    throw new Error('No checkout pages returned')
  }

  return first.path
}
